<section class="summary-card">
  <h2>Caractéristiques</h2>
  @if (parcs().length > 0) {
    <ul class="feature-list">
      @for (parc of parcs(); track parc.id) {
        <li>
          <span>
            <span class="material-symbols-outlined">{{ parc.global ? 'travel_explore' : 'solar_power' }}</span>
            <span style="vertical-align: super;">Parc {{ parc.libelle }} :</span>
          </span>
          <strong>{{ parc.nbInstallations }} centrales</strong>
        </li>
      }
    </ul>
  }

  <div class="map-card">
    <app-carte-installations [installations]="installations()" />
  </div>
</section>
